// extracted by mini-css-extract-plugin
export default {"homeBox":"Home_homeBox__VDl24","leftDim":"Home_leftDim__A60IB","rightDim":"Home_rightDim__pxQrc","deCenter":"Home_deCenter__TI-7F"};